export default __webpack_public_path__ + "static/media/Low-Volume.22fc043b.jpg";